import { Box, Button, Checkbox, Input, Tbody, Td, Th, Thead, Tooltip, Tr } from "@chakra-ui/react";
import { EditFormIcon, InfoFormDefault, SearchAdd, TrashIcon } from "~misc/icons";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { initialPath } from "~misc/paths";

import { randomId, utils } from "../../../../utils";
import useUnsavedChangesWarningFunil from "~components/Form/hooks/useUnsavedChangesWarningFunil";
import { SaveIndexBD } from "~services/utils/SaveIndexBD";
import TableInputTab from "./TableInputTab"

const TableContent = ({ data, headerValues, layoutData, handleDelete }) => {
  /**
   * Seleciona todos os checkboxes dentro da tabela
   * @param {import("react").ChangeEvent} event
   * @param {import("react").HTMLAttributes<HTMLInputElement>} event.target
   * @returns
   *
   */
  const handleSelectAll = ({ target }) => {
    const isInput = target instanceof HTMLInputElement;
    if (!isInput) return;
    if (target.getAttribute("type") != "checkbox") return;

    const table = target.closest(".funnel-table");
    const isChecked = target.checked;

    let tableCheckboxes;
    if (isChecked) {
      tableCheckboxes = table.querySelectorAll("input[type=checkbox]:not(:checked)");
    } else {
      tableCheckboxes = table.querySelectorAll("input[type=checkbox]:checked");
    }

    tableCheckboxes.forEach((checkbox) => {
      checkbox.click();
    });
  };
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [valuesInputs, setValuesInputs] = useState(null);
  const navigate = useNavigate();

  useUnsavedChangesWarningFunil(isFormDirty, navigate, 'Voltar');
  useEffect(() => {
    if(valuesInputs !== null){
      setIsFormDirty(true);
    }
  }, [valuesInputs]);

  return (
    <>
      {data?.header && (
        <Thead>
          <Tr>
            {/* Mostrará a opção de selecionar todos se for o primeiro <th>, tiver a propriedade showSelectAll e tiver um <tbody> */}
            {data?.showSelectAll && data?.body && (
              <Th>
                <Checkbox
                  className="bg-white mr-2"
                  id="select_all"
                  title="Selecionar todos"
                  onChange={handleSelectAll}
                />
              </Th>
            )}
            {data.header.data.map((item, index) => {
              return (
                <Th key={item.id}>
                  {item.label && (
                    <span className="field">
                      {item.label}
                    </span>
                  )}
                  <span className={`value ${item.class ?? ""}`}>{item.value}</span>
                  <TableInputTab item={item} setValuesInputs={setValuesInputs}></TableInputTab>
                </Th>
              );
            })}
            {data?.header?.actionButtons?.length > 0 && (
              <Th>
                <ActionButtons buttons={data.header.actionButtons} headerValues={headerValues} layoutData={layoutData} handleDelete={handleDelete} navigate={navigate} />
              </Th>
            )}
            {data.body?.actionButtons && !data.header.actionButtons && <Th />}
          </Tr>
        </Thead>
      )}

      {data?.body && (
        <Tbody>
          {data?.body.rows.map((row, index) => {
            return (
              <Tr key={index}>
                {row.columns.map((item, index) => {
                  return (
                    <Td key={item.id}>
                      <Box className={`${item.input?.type === "checkbox" ? "flex items-center" : ""}`}>
                        {item.input?.type === "checkbox" && (
                          <Checkbox
                            onBlur={item.input.onBlur}
                            onChange={(e) => {
                              item.input.onChange
                              setValuesInputs(e)
                            }}
                            className="bg-white mr-2"
                          />
                        )}

                        <div>
                          {item.label && (
                            <span className="field">
                              {item.label}

                              {item.tooltip && (
                                <Tooltip label={item.tooltip}>
                                  <InfoFormDefault className="icon" />
                                </Tooltip>
                              )}
                            </span>
                          )}
                          <span className={`value ${item.class ?? ""}`}>{item.value}</span>
                          <TableInputTab item={item} setValuesInputs={setValuesInputs}></TableInputTab>
                        </div>
                      </Box>
                    </Td>
                  );
                })}
                {data.body?.actionButtons?.length > 0 && (
                  <Td className="action-buttons-col">
                    <ActionButtons data={row?.dados} buttons={data.body.actionButtons} headerValues={headerValues} layoutData={layoutData} handleDelete={handleDelete} navigate={navigate} />
                  </Td>
                )}
              </Tr>
            );
          })}
        </Tbody>
      )}
    </>
  );
};

const ActionButtons = ({ data, buttons, headerValues, handleDelete, navigate }) => {
  const { parameter: idCliente } = useParams();

  const clienteId = idCliente ?? data?.clienteId;
  const idItem = headerValues?.id ?? data?.id ?? null;
  const isHeader = headerValues && Object.entries(headerValues)?.length > 0;
  const dataOrigin = Object.entries(headerValues || {})?.length > 0 ? headerValues : (data || {});
  const parameters = [];
  // const dashboard = `${dataOrigin?.dashboard ? "?dashboard=true" :""}`;

  if(dataOrigin?.dashboard) parameters.push({parameter: "dashboard", value: "true"});
  if(data?.obraAtiva) parameters.push({parameter: 'obra-ativa', value: 'true'});

  const urlParameter = (parameters?.length ? "?" : "") + parameters.map(e => `${e.parameter}=${e.value}`);
  
  return (
    buttons?.length > 0 ? (
      <div className="action-buttons-row">

        {buttons.includes("edit") && (
          <Link to={`${utils.modulePath}/${clienteId}/mapeamento/editar/${idItem}${urlParameter}`} className="action-button">
            <EditFormIcon className="icon" fill="#FFF" size={18} />
          </Link>
        )}

        {buttons.includes("create") && (
          <Link to={`${utils.modulePath}/${clienteId}/mapeamento${urlParameter}`} className="action-button" onClick={(e) => {
            e.preventDefault();

            let url = `${utils.modulePath}/${clienteId}/mapeamento${urlParameter}`;
            const dataFrom = isHeader ? dataOrigin : data;
            let params = [];

            url += `?ref=${dataFrom?.id}`
            params = {
              grupoId: dataFrom?.funilObraGrupoProdutoId,
              id: dataFrom?.id,
              etapa: dataFrom?.etapa,
              etapaSlug: dataFrom?.etapaSlug
            };

            SaveIndexBD(`criar-grupo-${dataFrom?.id}`, params);

            navigate(url);
          }}>
            <SearchAdd className="icon" fill="#FFF" size={40} />
          </Link>
        )}
        
        {buttons.includes("delete") && (
          <Link className="action-button delete" onClick={(e) => {
            e.preventDefault();
            const { funilObraGrupoProdutoId: grupo, etapa, etapaSlug, deleteBy, id } = dataOrigin;

            handleDelete({grupo, etapa, etapaSlug, deleteBy, id});
          }
          }>
            <TrashIcon size={40} />
          </Link>
        )}
      </div>
      )
    :
    <></>
  );
};

export default TableContent;
